import React from 'react';
import PropTypes from 'prop-types';

interface AnalyticsErrorProps {
  error: string;
}

export default class AnalyticsError extends React.Component<AnalyticsErrorProps, any> {
  render() {
    return (
      <div className="notification-container">
        <div className="alert alert-warning">
          <i className="fa fa-exclamation-triangle" />
          {this.props.error}
        </div>
      </div>
    );
  }
}
